import { createContext, useContext } from 'react';

export const ChatRetryContext = createContext<(() => void) | null>(null);

export const useChatRetry = () => useContext(ChatRetryContext);
